import http from '@/biz/http.mjs'

export default {

    create: (data) => http.post('/fmfcs', data),

    publish: (data) => http.put(
        '/fmfcs/rlsandrevise',
        {...data, stsCode: 'RLS'}
    ),

    pull: ({pkid}) => http.get(`/fmfcs/${pkid}/dps`),
    push: (data) => http.post('/fmfcs/batchmodify', data),
    read: ({pkid}) => http.get(`/fmfcs/${pkid}`),
    readList: (args) => http.get('/fmfcs', args),

    revise: ({pkid}) => http.put(
        '/fmfcs/rlsandrevise',
        {pkid, stsCode: 'REVISE'}
    ),

    update: (data) => http.put(`/fmfcs/${data.pkid}`, data),
    updateMap: (data) => http.put(`/fmfcs/${data.pkid}/map`, data),
}
